import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, DatePicker, Popover, Row, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { getSumTransaction } from "../../api/GatewayApi";
import ECard from "../../components/ECard";
import Histogram from "../../components/Histogram";
import { ColoredStatistic } from "../../components/Jarvis";

const { RangePicker } = DatePicker;
const formatter = (value) => {
  return new Intl.NumberFormat().format(value);
};

export default function DashboardPage() {
  const [fromdate, setFromdate] = useState();
  const [todate, setTodate] = useState();
  const [today_subtotal_amount, setTodaySubtotalAmount] = useState();
  const [todayMarginAmount, setTodayMarginAmount] = useState();
  const [totalMarginAmount, setTotalMarginAmount] = useState();
  const [todayVolume, setTodaylVolume] = useState();
  const [totalVolume, setTotalVolume] = useState();
  const [total_subtotal_amount, setTotalSubtotalAmount] = useState();

  const { refetch, isFetching } = useQuery(
    "getSumTransaction",
    getSumTransaction,
    {
      onSuccess: (data) => {
        if (data.code == 200) {
          setTodaySubtotalAmount(data.payload[0].today_subtotal_amount);
          setTodayMarginAmount(data.payload[0].today_margin_amount);
          setTotalMarginAmount(data.payload[0].total_margin_amount);
          setTotalSubtotalAmount(data.payload[0].total_subtotal_amount);
          setTotalVolume(data.payload[0].total_volume);
          setTodaylVolume(data.payload[0].today_volume);
        }
      },
      onError: (error) => {
        // TODO handle error
        console.log(error);
      },
    }
  );
  if (isFetching) {
    <Skeleton active />;
  }

  useEffect(() => {
    refetch();
  }, []);

  function handleDateRangeChange(dates, dateStrings) {
    setFromdate(dateStrings[0]);
    setTodate(dateStrings[1]);
  }

  // React.useEffect(() => {
  //   setInterval(() => {
  //     setTxnToday((txnToday) => txnToday + (Math.floor(Math.random() * (1000 - 500 + 1)) + 500));
  //   }, 1000);
  // }, []);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ECard>
          <Card.Grid style={{ width: "16.6%" }} hoverable={false}>
            <ColoredStatistic
              title="Today Volume"
              value={parseFloat(todayVolume) || 0}
              precision={2}
              formatter={formatter}
            />
          </Card.Grid>
          <Card.Grid style={{ width: "16.6%" }} hoverable={false}>
            <ColoredStatistic
              title="Today Subtotal Amount"
              value={parseFloat(today_subtotal_amount) || 0}
              precision={2}
              formatter={formatter}
            />
          </Card.Grid>
          <Card.Grid style={{ width: "16.6%" }} hoverable={false}>
            <ColoredStatistic
              title="Today Margin Amount"
              value={parseFloat(todayMarginAmount) || 0}
              precision={2}
              formatter={formatter}
            />
          </Card.Grid>
          <Card.Grid style={{ width: "16.6%" }} hoverable={false}>
            <ColoredStatistic
              title="Total Volume"
              value={parseFloat(totalVolume) || 0}
              precision={2}
              formatter={formatter}
            />
          </Card.Grid>
          <Card.Grid style={{ width: "16.6%" }} hoverable={false}>
            <ColoredStatistic
              title="Total Subtotal Amount"
              value={parseFloat(total_subtotal_amount) || 0}
              precision={2}
              formatter={formatter}
            />
          </Card.Grid>
          <Card.Grid style={{ width: "17%" }} hoverable={false}>
            <ColoredStatistic
              title="Total Margin Amount"
              value={parseFloat(totalMarginAmount) || 0}
              precision={2}
              formatter={formatter}
            />
          </Card.Grid>
        </ECard>
      </Col>
      <Col span={24}>
        <ECard
          title={
            <>
              Transactions
              <span style={{ margin: "0 3px" }}></span>
              <Popover content="If start day and end day is empty, there will show 90 days transactions">
                <InfoCircleOutlined />
              </Popover>
              {/* <br /> */}
              <span style={{ margin: "0 10px" }}></span>
              <RangePicker onChange={handleDateRangeChange} />
            </>
          }
        >
          {/* <LineChart fromdate={fromdate} todate={todate}/> */}
          <Histogram fromdate={fromdate} todate={todate} />
        </ECard>
      </Col>
    </Row>
  );
}
